import { Box, Skeleton } from "@mui/material";

const InstalledBaseSkeleton = () => {
    return (
        <Box>
            {[1, 1, 1].map((x, i) => (
                <Box key={i} sx={{ position: "relative" }}>
                    <Skeleton
                        sx={{ marginTop: "40px" }}
                        height={65}
                        variant="rectangular"
                    />
                    <Skeleton
                        variant="circular"
                        sx={{
                            position: "absolute",
                            top: -25,
                            left: 5,
                            borderRadius: 100,
                            width: 65,
                            height: 65,
                        }}
                    />
                    <Skeleton
                        variant="rectangular"
                        sx={{
                            position: "absolute",
                            top: "50%",
                            right: 16,
                            transform: "translate(0, -50%)",
                            width: 24,
                            height: 24,
                        }}
                    />
                </Box>
            ))}
        </Box>
    );
};

export default InstalledBaseSkeleton;
